declare global {
    interface Window {
        dataLayer: Record<string, unknown>[];
    }
}

window.dataLayer = window.dataLayer || [];

export const trackEvent = (event: string, params?: Record<string, unknown>) => {
    window.dataLayer.push({event, ...params});
};
